import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface SidebarContextType {
  expanded: boolean;
  toggleSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [expanded, setExpanded] = useState<boolean>(() => {
    const saved = localStorage.getItem('sidebarExpanded');
    return saved === 'true';
  });

  useEffect(() => {
    const initialExpanded = localStorage.getItem('sidebarExpanded') === 'true';
    document.documentElement.style.setProperty('--sidebar-width', initialExpanded ? '160px' : '60px');
  }, []);

  useEffect(() => {
    localStorage.setItem('sidebarExpanded', String(expanded));
    document.documentElement.style.setProperty('--sidebar-width', expanded ? '160px' : '60px');
  }, [expanded]);

  const toggleSidebar = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <SidebarContext.Provider value={{ expanded, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar должен использоваться внутри SidebarProvider');
  }
  return context;
};
